module.exports = __webpack_public_path__ + "static/googleplay-88dac222a3ec947161d8cd3c86c4b2cc.png";